import { getTeamUrl } from '../../../Common';
import { getProps } from '../props';

export default () => async () => {
  const { history } = getProps();
  history.push(getTeamUrl('suppliers'));
}
